module.exports = __webpack_public_path__ + "static/media/twitter.15a41d01.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/twitter.svg
// module id = 199
// module chunks = 0